export default __webpack_public_path__ + "static/media/events.9195d90a.svg";